module.exports = __webpack_public_path__ + "6d3b2e8a1792095d7fac9deeafc54792.svg";